import { ebsPassportSnilsPng, ebsPassportPng, ebsBiometryPng, ebsEsiaNumbersPng, ebsEsiaConfirmPng } from '@src/assets';
import { UNBREAKABLE_SEPARATOR } from '@src/constants/unbreakableSeparator';
import { sendClickEsiaEbsBanner, sendClickEsiaLkEbsBanner } from '@src/helpers/analyticsEvents';

import { EbsCustomAlert } from './components/EbsCustomAlert/EbsCustomAlert';

export const EBS_APP_LINK = `https://ebs.ru/verification_gosuslugi`;
export const EBS_ESIA_LK_LINK = `https://esia.gosuslugi.ru/`;

export const EBS_DEFAULT_GUIDE_ALERT_DESKTOP = `Нужен загранпаспорт нового образца и телефон с NFC`;

export const EBS_DEFAULT_GUIDE_ALERT_MOBILE = (
  <>
    Нужен загранпаспорт нового образца <br /> и телефон с NFC
  </>
);

export const EBS_RADIO_OPTIONS = [
  {
    label: 'Стандартная',
    value: 1,
  },
  {
    label: 'Подтверждённая',
    value: 2,
  },
];

export const EBS_DEFAULT_CONTENT = (isMobile: boolean) => [
  {
    title: (
      <div>
        Скачайте приложение <br />
        <a href={EBS_APP_LINK} target="_blank" rel="noreferrer noopener" onClick={sendClickEsiaEbsBanner}>
          «Госуслуги Биометрия»
        </a>
      </div>
    ),
  },

  {
    title: isMobile ? (
      <>
        Войдите{UNBREAKABLE_SEPARATOR}в{UNBREAKABLE_SEPARATOR}Госуслуги{UNBREAKABLE_SEPARATOR}и{UNBREAKABLE_SEPARATOR}
        дайте
        <br /> согласие на обработку
        <br /> данных
      </>
    ) : (
      <>Войдите в Госуслуги и дайте согласие на обработку данных</>
    ),
    image: ebsPassportSnilsPng,
  },
  {
    title: isMobile ? (
      <>
        Отсканируйте загранпаспорт{UNBREAKABLE_SEPARATOR}и{UNBREAKABLE_SEPARATOR}считайте зашифрованные
        {UNBREAKABLE_SEPARATOR}данные паспорта{UNBREAKABLE_SEPARATOR}телефоном с{UNBREAKABLE_SEPARATOR}NFC
      </>
    ) : (
      <>
        Отсканируйте загранпаспорт <br />и считайте зашифрованные данные паспорта{UNBREAKABLE_SEPARATOR}телефоном <br />{' '}
        с{UNBREAKABLE_SEPARATOR}NFC
      </>
    ),
    image: ebsPassportPng,
    imageStyles: {
      height: 107,
      width: 89,
      margin: '0 11px 0 0',
    },
  },
  {
    title: `Сделайте селфи, следуя подсказкам`,
    image: ebsBiometryPng,
    imageStyles: {
      height: 107,
      width: 89,
      margin: '0 11px 0 0',
    },
  },
  {
    title: `Произнесите три последовательности цифр`,
    image: ebsEsiaNumbersPng,
    imageStyles: {
      height: 107,
      width: 89,
      margin: '0 11px 0 0',
    },
  },
  {
    title: `Готово! У вас теперь есть стандартная биометрия`,
    image: ebsEsiaConfirmPng,
    imageStyles: {
      height: 107,
      width: 89,
      margin: '0 11px 0 0',
    },
  },
];

export const EBS_CONFIRM_CONTENT = (_isMobile: boolean) => [
  {
    title: 'Выберите любой ближайший офис банка',
    subtitle: (
      <EbsCustomAlert
        isSmallFont
        content={
          <>
            Быть клиентом банка не обязательно, эта{UNBREAKABLE_SEPARATOR}услуга{UNBREAKABLE_SEPARATOR}совершенно
            бесплатная
          </>
        }
      />
    ),
  },
  {
    title: `Не забудьте паспорт и СНИЛС — они нужны для регистрации`,
    image: ebsPassportSnilsPng,
  },
  {
    title: `Сотрудник банка сделает ваше фото и запишет голос`,
    image: ebsPassportPng,
    imageStyles: {
      height: 107,
      width: 89,
      margin: '0 11px 0 0',
    },
  },
  {
    title: (
      <span>
        Управлять биометрией можно
        <a
          href={EBS_ESIA_LK_LINK}
          target="_blank"
          style={{ textDecoration: 'none' }}
          rel="noreferrer noopener"
          onClick={sendClickEsiaLkEbsBanner}
        >
          {UNBREAKABLE_SEPARATOR}в{UNBREAKABLE_SEPARATOR}личном кабинете Госуслуг
        </a>
      </span>
    ),
    image: ebsBiometryPng,
    imageStyles: {
      height: 107,
      width: 89,
      margin: '0 11px 0 0',
    },
  },
];
